import React from 'react';
import { MdArrowDownward, MdWarning, MdInfo } from 'react-icons/md';

const PromotionStatusBadge = ({ 
  status, 
  nextClass, 
  studentCount = 0,
  className = "" 
}) => {
  const getStatusConfig = () => {
    // Check if this is the last class (highest class in the hierarchy)
    if (status?.is_last_class) {
      if (studentCount === 0) {
        return {
          icon: <MdInfo className="text-blue-500" size={16} />,
          text: "Final Class",
          bgColor: "bg-blue-100",
          textColor: "text-blue-800",
          borderColor: "border-blue-200"
        };
      }
      return {
        icon: <MdArrowDownward className="text-blue-500" size={16} />,
        //text: `Ready to Graduate (${studentCount})`,
        text: "Final Class",
        bgColor: "bg-blue-100",
        textColor: "text-blue-800",
        borderColor: "border-blue-200"
      };
    }

    if (!nextClass) {
      return {
        icon: <MdWarning className="text-orange-500" size={16} />,
        text: "No Next Class",
        bgColor: "bg-orange-100",
        textColor: "text-orange-800",
        borderColor: "border-orange-200"
      };
    }

    if (studentCount === 0) {
      return {
        icon: <MdInfo className="text-blue-500" size={16} />,
        text: "No Students",
        bgColor: "bg-blue-100",
        textColor: "text-blue-800",
        borderColor: "border-blue-200"
      };
    }

    return {
      icon: <MdArrowDownward className="text-green-500" size={16} />,
      //text: `Ready to Promote (${studentCount})`,
      bgColor: "bg-green-100",
      textColor: "text-green-800",
      borderColor: "border-green-200"
    };
  };

  const config = getStatusConfig();

  return (
    <div className={`inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium border ${config.bgColor} ${config.textColor} ${config.borderColor} ${className}`}>
      {config.icon}
      <span className="ml-1.5">{config.text}</span>
      {nextClass && studentCount > 0 && (
        <span className="ml-2 text-xs opacity-75">
          → {nextClass.class_name}
        </span>
      )}
    </div>
  );
};

export default PromotionStatusBadge;
